var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999913 3.41L5.57991 8L0.999912 12.59L2.40991 14L8.40991 8L2.40991 2L0.999913 3.41Z",
    fill: "#F0EDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 3.41L11.5799 8L6.99991 12.59L8.40991 14L14.4099 8L8.40991 2L6.99991 3.41Z",
    fill: "#F0EDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastGrey);
export default __webpack_public_path__ + "static/media/lastGrey.ec170cf929195b7dbb3c7381c76b45e0.svg";
export { ForwardRef as ReactComponent };